import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { anaBlue } from './Ana';

const useStyles = makeStyles((theme) => ({
  root: {
    background: `repeating-linear-gradient(-60deg, ${anaBlue}, ${anaBlue} 20px, white 20px, white 30px)`,
    height: 10,
    width: '100%',
  },
}));

const StripeLine = () => {
  const classes = useStyles();
  return <div className={classes.root} />;
};

export default StripeLine;
